import Client from 'config/axios';

export const getDownloadUrl = async (token: string, fileUrl: string) => {
  const { data } = await Client.get('download-s3-file', {
    params: { fileUrl },
    headers: {
      Authorization: `Bearer ${token}`
    }
  });
  return data.data.downloadUrl;
};
